<template>

<div class="overlay-wrapper">
   <div class="overlay" style="flex-direction: column;">
       <i class="fas fa-3x fa-sync-alt fa-spin"></i>
       <div class="text-bold pt-2">Loading...</div></div>
    </div>

</template>
<script>

export default {
    
    
 
    mounted(){
  
        const token = this.$route.query.token;
        localStorage.token = token;
        console.log(token)
        window.location.href = this.$store.state.asistencia+'/home'
       
    }
}
</script>